import { render, staticRenderFns } from "./tab-super-quick-pick.vue?vue&type=template&id=53f6a80f&scoped=true&"
import script from "./tab-super-quick-pick.vue?vue&type=script&lang=js&"
export * from "./tab-super-quick-pick.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/loto/tab-common.scss?vue&type=style&index=0&id=53f6a80f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6a80f",
  null
  
)

export default component.exports